// extracted by mini-css-extract-plugin
export default {"container":"dG-z","disabled":"eG-z","bgBlack":"fG-z","content":"gG-z","countdown":"hG-z","topCaption":"iG-z","topHeading":"jG-z","heading":"kG-z","copy":"lG-z"};